import { render } from "./EditClaimExpenseType.vue?vue&type=template&id=4dc24a28&scoped=true"
import script from "./EditClaimExpenseType.vue?vue&type=script&lang=js"
export * from "./EditClaimExpenseType.vue?vue&type=script&lang=js"

import "../save-claim-event.scss?vue&type=style&index=0&id=4dc24a28&lang=scss&scoped=true"

import exportComponent from "/home/paperspace/thehrway-basic/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc24a28"]])

export default __exports__